exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.close-project-cart[data-v-7a015404] {\n    position: absolute;\n    right: 0;\n}\n", ""]);

// exports
